/**
 * Estimate Cost-Breakdown binding contract
 * ────────────────────────────────────────
 * The typed shape fed to the CI (Continuous Improvement) estimate Excel export's
 * cost-breakdown sections. The export collapses the per-role resource plan into two
 * buckets - Project Management and Consulting (everything not-PM) - plus a Grand
 * Total, rendered with Low/Med/High columns in both HOURS and DOLLARS.
 *
 * Two parallel arrays, one per rendered Excel block, because the contract renderer
 * applies one static number format per dynamic block:
 *   - `hours`   → numFmt "#,##0"  (Consulting / PM / Grand Total, in hours)
 *   - `dollars` → numFmt "$#,##0" (the same buckets in dollars; labels carry the
 *                 assumed average rate; optional Discount / Net Total rows appended)
 *
 * `low`/`high` are NULLABLE so a deal with the estimate range disabled blanks the
 * Low & High cells (the renderer maps `null` → an empty cell) while keeping Med
 * populated. `med` is always present.
 *
 * Computed by `buildCostBreakdown` (packages/shared/src/utils/cost-breakdown.ts) and
 * consumed by the `deal:estimate` export route (apps/api/src/routes/sales.ts).
 */
import { z } from 'zod';
export const costBreakdownRowSchema = z.object({
    label: z.string().min(1),
    low: z.number().nullable(),
    med: z.number(),
    high: z.number().nullable(),
});
export const costBreakdownSchema = z.object({
    /** numFmt "#,##0" block - hours rows (Consulting / PM / Grand Total). */
    hours: z.array(costBreakdownRowSchema),
    /** numFmt "$#,##0" block - dollar rows (same buckets + optional Discount / Net Total). */
    dollars: z.array(costBreakdownRowSchema),
});
//# sourceMappingURL=cost-breakdown.js.map